/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Approve_LabelInputs */

const en_context_menu_approve_label = /** @type {(inputs: Context_Menu_Approve_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approve selected events`)
};

const fr_context_menu_approve_label = /** @type {(inputs: Context_Menu_Approve_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approuver les événements sélectionnés`)
};

const de_context_menu_approve_label = /** @type {(inputs: Context_Menu_Approve_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genehmigen Sie ausgewählte Ereignisse`)
};

const it_context_menu_approve_label = /** @type {(inputs: Context_Menu_Approve_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approva gli eventi selezionati`)
};

const ru_context_menu_approve_label = /** @type {(inputs: Context_Menu_Approve_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Одобрить выбранные события`)
};

const es_context_menu_approve_label = /** @type {(inputs: Context_Menu_Approve_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprobar eventos seleccionados`)
};

const zh_cn2_context_menu_approve_label = /** @type {(inputs: Context_Menu_Approve_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`批准选定事件`)
};

const ja_context_menu_approve_label = /** @type {(inputs: Context_Menu_Approve_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したイベントを承認する`)
};

const hi_context_menu_approve_label = /** @type {(inputs: Context_Menu_Approve_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित घटनाओं को अनुमोदित करें`)
};

const pt_pt2_context_menu_approve_label = /** @type {(inputs: Context_Menu_Approve_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aprovar eventos selecionados`)
};

/**
* | output |
* | --- |
* | "Approve selected events" |
*
* @param {Context_Menu_Approve_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_approve_label = /** @type {((inputs?: Context_Menu_Approve_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Approve_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_approve_label(inputs)
	if (locale === "de") return de_context_menu_approve_label(inputs)
	if (locale === "it") return it_context_menu_approve_label(inputs)
	if (locale === "ru") return ru_context_menu_approve_label(inputs)
	if (locale === "es") return es_context_menu_approve_label(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_approve_label(inputs)
	if (locale === "ja") return ja_context_menu_approve_label(inputs)
	if (locale === "hi") return hi_context_menu_approve_label(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_approve_label(inputs)
	return en_context_menu_approve_label(inputs)
});